import React from 'react';

const B = props => (
    <div style={{
        fontWeight: props.text ? "bold" : undefined,
        display: "inline-block",
    }}>
        {props.text || props.alt}
    </div>
);

export default B;


// WEBPACK FOOTER //
// ./src/pages/B.js